import { render } from "./view-contract-list-old.vue?vue&type=template&id=381bf791"
import script from "./view-contract-list-old.vue?vue&type=script&lang=js"
export * from "./view-contract-list-old.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/view-contract-list/view-contract-list-old.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "381bf791"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('381bf791', __exports__)) {
    api.reload('381bf791', __exports__)
  }
  
  module.hot.accept("./view-contract-list-old.vue?vue&type=template&id=381bf791", () => {
    api.rerender('381bf791', render)
  })

}


export default __exports__